// Hospitality H1 (Sep 2026) — a slim strip on the restaurant storefront
// telling a hotel-referred guest where their food is going, with a way
// back to the hotel's restaurant list.
import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function HostReferralBanner({ context, error }) {
  if (error && !context) {
    return (
      <div className="bg-amber-100 text-amber-900 text-sm px-4 py-2 text-center" role="alert" data-testid="host-referral-error">
        {error}
      </div>
    );
  }
  if (!context) return null;
  return (
    <div className="bg-emerald-50 text-emerald-950 border-b border-emerald-200" data-testid="host-referral-banner">
      <div className="mx-auto max-w-5xl px-4 py-2 flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="inline-flex items-center gap-1.5">
          <Lock className="h-3.5 w-3.5" aria-hidden="true" />
          Delivering to <strong className="font-semibold">{context.host_display_name}</strong> — {context.receiving_point || "Front Desk"}
        </span>
        {context.host_slug && (
          <Link to={`/dine/${context.host_slug}`} className="text-emerald-800 underline underline-offset-2">
            Other restaurants
          </Link>
        )}
      </div>
    </div>
  );
}
